//#region src/components/_overlay/focus.ts
var FOCUSABLE = [
	"a[href]",
	"area[href]",
	"button:not([disabled])",
	"input:not([disabled]):not([type=\"hidden\"])",
	"select:not([disabled])",
	"textarea:not([disabled])",
	"iframe",
	"audio[controls]",
	"video[controls]",
	"summary",
	"[contenteditable]:not([contenteditable=\"false\"])",
	"[tabindex]"
].join(",");
function isVisible(element) {
	if (element.closest("[hidden], [inert]")) return false;
	return typeof element.checkVisibility === "function" ? element.checkVisibility({ visibilityProperty: true }) : true;
}
/** The elements inside `root` that Tab reaches, in DOM order. */
function tabbables(root) {
	return Array.from(root.querySelectorAll(FOCUSABLE)).filter((element) => element.tabIndex >= 0 && isVisible(element));
}
/**
* Focuses `preferred` if given, else the first tabbable element in `root`, else `root`
* itself (made focusable with tabindex="-1" if it isn't already).
*/
function focusFirst(root, preferred) {
	const target = preferred ?? tabbables(root)[0];
	if (target) {
		target.focus();
		return;
	}
	if (!root.hasAttribute("tabindex")) root.setAttribute("tabindex", "-1");
	root.focus();
}
/** True if focus can go back to `element`: still in the document, and not disabled. */
function canFocus(element) {
	return element instanceof HTMLElement && element.isConnected && element !== document.body && !element.matches(":disabled") && !element.closest("[inert]");
}
//#endregion
export { canFocus, focusFirst, tabbables };

//# sourceMappingURL=focus.js.map